export default __webpack_public_path__ + "static/media/applyMaterialIcon.c70161d0.svg";